import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import CallTableViewModel from "../../../ViewModels/CallTableViewModel";
import SalesAIDialog from "./SalesAIDialog";
import FilterChipDisplay from "../../FilterChipDisplay";

interface IFiltersProps {
    callTableViewModel: CallTableViewModel
    setCallTableViewModel: (value: CallTableViewModel) => void
}

export default function SalesAI({ callTableViewModel, setCallTableViewModel }: IFiltersProps) {
    const [open, setOpen] = useState(false);

    const text =
        <Typography variant="body1">
            {
                "Sales-AI - "
            }
            {
                (callTableViewModel.filters.salesAI.question !== '') ?
                    callTableViewModel.filters.salesAI.question + ' - ' + callTableViewModel.filters.salesAI.answer
                    : ' Is Any'
            }
        </Typography>

    return (
        <>
            <FilterChipDisplay
                text={text}
                selectable
                onClick={() => setOpen(true)} />
            <SalesAIDialog
                open={open}
                setOpen={setOpen}
                callTableViewModel={callTableViewModel}
                setCallTableViewModel={setCallTableViewModel}
            />
        </>
    )
}